module.exports = __webpack_public_path__ + "static/media/lines.5951b642.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/form/Type/lines.svg
 ** module id = 193
 ** module chunks = 0
 **/